module.exports = "<template>\r\n\t<i class=\"boolean-icon la ${value === true ? 'la-check text-success' : 'la-times text-danger'}\"></i>\r\n</template>";